import {FC} from "react";
import {Colors, FlexBox, HintTooltip, useBreakpoint} from "@brg/ui";
import styled, { useTheme } from "styled-components";
import {useTranslation} from "react-i18next";
import {RectangularButtonFilled} from "../../../components/buttons";
import {LayoutConst, useModal} from "../../../../core";
import {getTooltipStyles, tooptipStylesWhite} from "../../../constants/tooptipStyles";
import {RectButtonWrapper} from "../../../features/QueuePaymenrt/payment/CheckOut/styles";
import {QuestionButtonIcon} from "../../../features/QueuePaymenrt/payment/CheckOut/assets/QuestionButton";
import {AppTester} from "../../../../supporting";
import {AddButtonIcon} from "../../../features/QueuePaymenrt/payment/CheckOut/assets/AddButton";
import {FlorinIcon} from "../../../icons/FlorinIcon/FlorinIcon";
import {BookPaymentData} from "../../../hooks/useGetBookPaymentData";
import {useUserBalance} from "../../../features/QueuePaymenrt/hooks/useUserBalance";
import { setFlowType } from "shared/features/QueuePaymenrt/slices/OrderSlice";
import { FlowType } from "shared/features/QueuePaymenrt/constants/flowType";
import { useDispatch } from "react-redux";

const Wrapper = styled(FlexBox)`
    gap: 32px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        gap: 16px;
    }
`
const Label = styled(FlexBox)`
    color: ${Colors.galBlack100};
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    width: 122px;
    min-width: 122px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
        width: 95px;
        min-width: 95px;
    }
`
const LabelBig = styled(FlexBox)`
    color: ${Colors.galBlack100};
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
`
const PaymentContainer = styled(FlexBox)<{ type?: 'small' | 'large' }>`
    color: ${Colors.galBlack100};
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    background: ${Colors.galBlack5};
    border-radius: 3px;
    flex-direction: column;
    display: flex;

    width: 100%;
    gap: ${({type}) => type === 'small' ? '12px' : '8px'};
    padding: ${({type}) => type === 'small' ? '8px 16px' : '12px 16px 16px 16px'};
    
    svg {
        path {
            fill: ${Colors.galBlack47};
        }
        rect {
            stroke: ${Colors.galBlack47};
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
        padding: ${({type}) => type === 'small' ? '8px 16px' : '8px 16px 12px 16px'};
    }
`

const GreyText = styled(FlexBox)`
    color: ${Colors.galBlack47};
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 11px;
        line-height: 13px;
    }
`
const GreyTextMedium = styled(FlexBox)`
    color: ${Colors.galBlack47};
    font-size: 11px;
    line-height: 13px;
    font-weight: 400;
    align-items: center;
`
const GreyTextSmall = styled(FlexBox)`
    color: ${Colors.galBlack47};
    font-size: 10px;
    font-weight: 400;
    line-height: 13px;
    align-items: center;
`
const GreySplitLine = styled(FlexBox)`
    background: ${Colors.galBlack47};
    width: 1px;
    height: 100%;
`

export const QueueButtonFilled = styled(RectangularButtonFilled)`

  height: 28px !important;
  width: 176px !important;
    padding: 0 !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
`;

const getSplittedPrice = (price: number) => {
    return  price.toLocaleString('ru-RU');
}

export const BookBuyProcessingComponent: FC<{bookPaymentData: BookPaymentData}> = ({bookPaymentData}) => {

    const { t } = useTranslation()
    const modal = useModal()
    const theme = useTheme();
    const dispatch = useDispatch()
    const isDeziiignBooks = AppTester.isBooksMain()
    const { onBuy, price } = bookPaymentData
    const { userBalance } = useUserBalance()
    const is992 = useBreakpoint(LayoutConst.screen.m);

    const {priceRouble, priceFlorin, priceZephyr, rate} = price

    const onAddClick = () => {
        dispatch(setFlowType(FlowType.TOPUP_BALANCE))
        modal.show('topUpBalance', {
            isOpen: true,
            // close: () => modal.hide(), // todo: выяснить, зачем это здесь
            containerStyles: {
                background: 'rgba(231,231,231, 1)',
                backdropFilter: 'none'
            }
        })
    }

    const onSubmit = () => {
        onBuy && onBuy()
    }

     return <Wrapper width="100%" direction="column" directionMobile="column">
         <FlexBox width="100%" justify="space-between" gx={is992 ? 0 : 16} gy={is992 ? 8 : 0} direction={is992 ? "column" : "row"}>
            <Label>{t('book_buy_processing.variants')}</Label>
            <PaymentContainer type="large">
                <FlexBox width="100%" justify="space-between">
                    <span>{t('book_buy_processing.digital_version')}</span>
                    <Label>{getSplittedPrice(priceRouble?.rouble || 0)} ₽</Label>
                </FlexBox>
                <FlexBox width="100%" gy={24} direction="column">
                    <FlexBox gx={16}>
                        <FlexBox gy={4} direction="column">
                            <GreyText>{getSplittedPrice(priceRouble?.rouble || 0)} ₽</GreyText>
                            <GreyTextSmall>{t('book_buy_processing.roubles')}</GreyTextSmall>
                        </FlexBox>
                        <GreySplitLine/>
                        <FlexBox gy={4} direction="column">
                            <GreyText>{getSplittedPrice(priceZephyr?.rouble || 0)} ₽ + {getSplittedPrice(priceZephyr?.zephyr || 0)} <FlorinIcon
                                margin='4'
                                mobileSize={1}
                                size={1}
                                style={{ marginLeft: '4px' }}
                            /></GreyText>
                            <GreyTextSmall>{t('book_buy_processing.zephyrs')}</GreyTextSmall>
                        </FlexBox>
                        <GreySplitLine/>
                        <FlexBox gy={4} direction="column">
                            <GreyText>{getSplittedPrice(priceFlorin?.rouble || 0)} ₽ + {getSplittedPrice(priceFlorin?.florin || 0)} <FlorinIcon
                                newIcon
                                margin='4'
                                mobileSize={1}
                                size={1}
                                style={{ marginLeft: '4px' }}
                            /></GreyText>
                            <GreyTextSmall>{t('book_buy_processing.florins')}</GreyTextSmall>
                        </FlexBox>
                    </FlexBox>
                    <FlexBox width="100%" justify="flex-end">
                        <QueueButtonFilled onClick={onSubmit}>{t('book_buy_processing.go_to_payment')}</QueueButtonFilled>
                    </FlexBox>
                </FlexBox>
            </PaymentContainer>

         </FlexBox>
         <FlexBox width="100%" justify="space-between" gx={is992 ? 0 : 16} gy={is992 ? 8 : 0} direction={is992 ? "column" : "row"}>
             <Label>{t('book_buy_processing.your_balance')}</Label>
             <FlexBox direction="column" gy={8} width="100%">
                 <PaymentContainer type="small">
                     <div>{t('book_buy_processing.zephyrs')}</div>
                     <FlexBox justify="space-between" align="flex-end">
                         <FlexBox direction="column" gy={4}>
                             <LabelBig>{getSplittedPrice(Number((userBalance?.RealMoney || 0).toFixed(2)))} <FlorinIcon
                                 margin='4'
                                 mobileSize={1.5}
                                 size={1.5}
                                 style={{ marginLeft: '4px' }}
                             /></LabelBig>
                             <GreyTextSmall>{t('book_buy_processing.bonus_account')}</GreyTextSmall>
                         </FlexBox>
                         <FlexBox gx={8}>
                             <HintTooltip
                                 //@ts-ignore
                                 customStyle={isDeziiignBooks ? tooptipStylesWhite : getTooltipStyles(theme as any)}
                                 text={t("payment.payment_method.top_up")}
                                 positionY="top"
                                 textOffset={""}
                                 closeToRightCorner={true}
                             >
                                 <RectButtonWrapper className="addButton" onClick={onAddClick} >
                                     <AddButtonIcon />
                                 </RectButtonWrapper>
                             </HintTooltip>
                             <HintTooltip
                                 //@ts-ignore
                                 customStyle={isDeziiignBooks ? tooptipStylesWhite : getTooltipStyles(theme as any)}
                                 //@ts-ignore
                                 text={t(`payment.payment_method.zephyr_info`)}
                                 ptextOffset={""}
                                 closeToRightCorner={true}
                             >
                                 <RectButtonWrapper>
                                     <QuestionButtonIcon />
                                 </RectButtonWrapper>
                             </HintTooltip>
                         </FlexBox>
                         </FlexBox>
                 </PaymentContainer>
                 <PaymentContainer type="small">
                     <FlexBox align="center" justify="space-between">
                         <div>{t('book_buy_processing.florins')}</div>
                         <GreyTextMedium>{(t('book_buy_processing.rate'))}: {rate || 0.001} <FlorinIcon
                             margin='4'
                             mobileSize={1}
                             size={1}
                             style={{ marginLeft: '4px' }}
                         /></GreyTextMedium>
                     </FlexBox>
                     <FlexBox justify="space-between" align="flex-end">
                         <FlexBox direction="column" gy={4}>
                             <LabelBig>{getSplittedPrice(Number((userBalance?.PlayMoney || 0).toFixed(2)))} <FlorinIcon
                                 newIcon
                                 margin='4'
                                 black
                                 mobileSize={1.5}
                                 size={1.5}
                                 style={{ marginLeft: '4px' }}
                             /></LabelBig>
                             <GreyTextSmall>{t('book_buy_processing.bonus_account')}</GreyTextSmall>
                         </FlexBox>
                         <HintTooltip
                             //@ts-ignore
                             customStyle={isDeziiignBooks ? tooptipStylesWhite : getTooltipStyles(theme as any)}
                             //@ts-ignore
                             hidden={false}
                             text={t(`payment.payment_method.florin_info`)} 
                             textOffset={""}
                             closeToRightCorner={true}
                            //  textOffset={!is1440BP ? "calc(-50% + 8px)" : "-38px"}
                         >
                             <RectButtonWrapper>
                                 <QuestionButtonIcon />
                             </RectButtonWrapper>
                         </HintTooltip>
                     </FlexBox>
                 </PaymentContainer>
             </FlexBox>
         </FlexBox>
     </Wrapper>
}import {FC} from "react";
import {Colors, FlexBox, HintTooltip, useBreakpoint} from "@brg/ui";
import styled, { useTheme } from "styled-components";
import {useTranslation} from "react-i18next";
import {RectangularButtonFilled} from "../../../components/buttons";
import {LayoutConst, useModal} from "../../../../core";
import {getTooltipStyles, tooptipStylesWhite} from "../../../constants/tooptipStyles";
import {RectButtonWrapper} from "../../../features/QueuePaymenrt/payment/CheckOut/styles";
import {QuestionButtonIcon} from "../../../features/QueuePaymenrt/payment/CheckOut/assets/QuestionButton";
import {AppTester} from "../../../../supporting";
import {AddButtonIcon} from "../../../features/QueuePaymenrt/payment/CheckOut/assets/AddButton";
import {FlorinIcon} from "../../../icons/FlorinIcon/FlorinIcon";
import {BookPaymentData} from "../../../hooks/useGetBookPaymentData";
import {useUserBalance} from "../../../features/QueuePaymenrt/hooks/useUserBalance";
import { setFlowType } from "shared/features/QueuePaymenrt/slices/OrderSlice";
import { FlowType } from "shared/features/QueuePaymenrt/constants/flowType";
import { useDispatch } from "react-redux";

const Wrapper = styled(FlexBox)`
    gap: 32px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        gap: 16px;
    }
`
const Label = styled(FlexBox)`
    color: ${Colors.galBlack100};
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    width: 122px;
    min-width: 122px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
        width: 95px;
        min-width: 95px;
    }
`
const LabelBig = styled(FlexBox)`
    color: ${Colors.galBlack100};
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
`
const PaymentContainer = styled(FlexBox)<{ type?: 'small' | 'large' }>`
    color: ${Colors.galBlack100};
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    background: ${Colors.galBlack5};
    border-radius: 3px;
    flex-direction: column;
    display: flex;

    width: 100%;
    gap: ${({type}) => type === 'small' ? '12px' : '8px'};
    padding: ${({type}) => type === 'small' ? '8px 16px' : '12px 16px 16px 16px'};
    
    svg {
        path {
            fill: ${Colors.galBlack47};
        }
        rect {
            stroke: ${Colors.galBlack47};
        }
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
        padding: ${({type}) => type === 'small' ? '8px 16px' : '8px 16px 12px 16px'};
    }
`

const GreyText = styled(FlexBox)`
    color: ${Colors.galBlack47};
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 11px;
        line-height: 13px;
    }
`
const GreyTextMedium = styled(FlexBox)`
    color: ${Colors.galBlack47};
    font-size: 11px;
    line-height: 13px;
    font-weight: 400;
    align-items: center;
`
const GreyTextSmall = styled(FlexBox)`
    color: ${Colors.galBlack47};
    font-size: 10px;
    font-weight: 400;
    line-height: 13px;
    align-items: center;
`
const GreySplitLine = styled(FlexBox)`
    background: ${Colors.galBlack47};
    width: 1px;
    height: 100%;
`

export const QueueButtonFilled = styled(RectangularButtonFilled)`

  height: 28px !important;
  width: 176px !important;
    padding: 0 !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
`;

const getSplittedPrice = (price: number) => {
    return  price.toLocaleString('ru-RU');
}

export const BookBuyProcessingComponent: FC<{bookPaymentData: BookPaymentData}> = ({bookPaymentData}) => {

    const { t } = useTranslation()
    const modal = useModal()
    const theme = useTheme();
    const dispatch = useDispatch()
    const isDeziiignBooks = AppTester.isBooksMain()
    const { onBuy, price } = bookPaymentData
    const { userBalance } = useUserBalance()
    const is992 = useBreakpoint(LayoutConst.screen.m);

    const {priceRouble, priceFlorin, priceZephyr, rate} = price

    const onAddClick = () => {
        dispatch(setFlowType(FlowType.TOPUP_BALANCE))
        modal.show('topUpBalance', {
            isOpen: true,
            // close: () => modal.hide(), // todo: выяснить, зачем это здесь
            containerStyles: {
                background: 'rgba(231,231,231, 1)',
                backdropFilter: 'none'
            }
        })
    }

    const onSubmit = () => {
        onBuy && onBuy()
    }

     return <Wrapper width="100%" direction="column" directionMobile="column">
         <FlexBox width="100%" justify="space-between" gx={is992 ? 0 : 16} gy={is992 ? 8 : 0} direction={is992 ? "column" : "row"}>
            <Label>{t('book_buy_processing.variants')}</Label>
            <PaymentContainer type="large">
                <FlexBox width="100%" justify="space-between">
                    <span>{t('book_buy_processing.digital_version')}</span>
                    <Label>{getSplittedPrice(priceRouble?.rouble || 0)} ₽</Label>
                </FlexBox>
                <FlexBox width="100%" gy={24} direction="column">
                    <FlexBox gx={16}>
                        <FlexBox gy={4} direction="column">
                            <GreyText>{getSplittedPrice(priceRouble?.rouble || 0)} ₽</GreyText>
                            <GreyTextSmall>{t('book_buy_processing.roubles')}</GreyTextSmall>
                        </FlexBox>
                        <GreySplitLine/>
                        <FlexBox gy={4} direction="column">
                            <GreyText>{getSplittedPrice(priceZephyr?.rouble || 0)} ₽ + {getSplittedPrice(priceZephyr?.zephyr || 0)} <FlorinIcon
                                margin='4'
                                mobileSize={1}
                                size={1}
                                style={{ marginLeft: '4px' }}
                            /></GreyText>
                            <GreyTextSmall>{t('book_buy_processing.zephyrs')}</GreyTextSmall>
                        </FlexBox>
                        <GreySplitLine/>
                        <FlexBox gy={4} direction="column">
                            <GreyText>{getSplittedPrice(priceFlorin?.rouble || 0)} ₽ + {getSplittedPrice(priceFlorin?.florin || 0)} <FlorinIcon
                                newIcon
                                margin='4'
                                mobileSize={1}
                                size={1}
                                style={{ marginLeft: '4px' }}
                            /></GreyText>
                            <GreyTextSmall>{t('book_buy_processing.florins')}</GreyTextSmall>
                        </FlexBox>
                    </FlexBox>
                    <FlexBox width="100%" justify="flex-end">
                        <QueueButtonFilled onClick={onSubmit}>{t('book_buy_processing.go_to_payment')}</QueueButtonFilled>
                    </FlexBox>
                </FlexBox>
            </PaymentContainer>

         </FlexBox>
         <FlexBox width="100%" justify="space-between" gx={is992 ? 0 : 16} gy={is992 ? 8 : 0} direction={is992 ? "column" : "row"}>
             <Label>{t('book_buy_processing.your_balance')}</Label>
             <FlexBox direction="column" gy={8} width="100%">
                 <PaymentContainer type="small">
                     <div>{t('book_buy_processing.zephyrs')}</div>
                     <FlexBox justify="space-between" align="flex-end">
                         <FlexBox direction="column" gy={4}>
                             <LabelBig>{getSplittedPrice(Number((userBalance?.RealMoney || 0).toFixed(2)))} <FlorinIcon
                                 margin='4'
                                 mobileSize={1.5}
                                 size={1.5}
                                 style={{ marginLeft: '4px' }}
                             /></LabelBig>
                             <GreyTextSmall>{t('book_buy_processing.bonus_account')}</GreyTextSmall>
                         </FlexBox>
                         <FlexBox gx={8}>
                             <HintTooltip
                                 //@ts-ignore
                                 customStyle={isDeziiignBooks ? tooptipStylesWhite : getTooltipStyles(theme as any)}
                                 text={t("payment.payment_method.top_up")}
                                 positionY="top"
                                 textOffset={""}
                                 closeToRightCorner={true}
                             >
                                 <RectButtonWrapper className="addButton" onClick={onAddClick} >
                                     <AddButtonIcon />
                                 </RectButtonWrapper>
                             </HintTooltip>
                             <HintTooltip
                                 //@ts-ignore
                                 customStyle={isDeziiignBooks ? tooptipStylesWhite : getTooltipStyles(theme as any)}
                                 //@ts-ignore
                                 text={t(`payment.payment_method.zephyr_info`)}
                                 ptextOffset={""}
                                 closeToRightCorner={true}
                             >
                                 <RectButtonWrapper>
                                     <QuestionButtonIcon />
                                 </RectButtonWrapper>
                             </HintTooltip>
                         </FlexBox>
                         </FlexBox>
                 </PaymentContainer>
                 <PaymentContainer type="small">
                     <FlexBox align="center" justify="space-between">
                         <div>{t('book_buy_processing.florins')}</div>
                         <GreyTextMedium>{(t('book_buy_processing.rate'))}: {rate || 0.001} <FlorinIcon
                             margin='4'
                             mobileSize={1}
                             size={1}
                             style={{ marginLeft: '4px' }}
                         /></GreyTextMedium>
                     </FlexBox>
                     <FlexBox justify="space-between" align="flex-end">
                         <FlexBox direction="column" gy={4}>
                             <LabelBig>{getSplittedPrice(Number((userBalance?.PlayMoney || 0).toFixed(2)))} <FlorinIcon
                                 newIcon
                                 margin='4'
                                 black
                                 mobileSize={1.5}
                                 size={1.5}
                                 style={{ marginLeft: '4px' }}
                             /></LabelBig>
                             <GreyTextSmall>{t('book_buy_processing.bonus_account')}</GreyTextSmall>
                         </FlexBox>
                         <HintTooltip
                             //@ts-ignore
                             customStyle={isDeziiignBooks ? tooptipStylesWhite : getTooltipStyles(theme as any)}
                             //@ts-ignore
                             hidden={false}
                             text={t(`payment.payment_method.florin_info`)} 
                             textOffset={""}
                             closeToRightCorner={true}
                            //  textOffset={!is1440BP ? "calc(-50% + 8px)" : "-38px"}
                         >
                             <RectButtonWrapper>
                                 <QuestionButtonIcon />
                             </RectButtonWrapper>
                         </HintTooltip>
                     </FlexBox>
                 </PaymentContainer>
             </FlexBox>
         </FlexBox>
     </Wrapper>
}